<template>
    <div class="mt-3 mx-2">
        <div class="d-flex justify-center mt-5 mb-5">
            <v-progress-circular color="primary" size="75" indeterminate />
        </div>

        <div v-if="!isLoading">
            <div class="d-flex flex-column align-center">
                <h2 class="align-self-center">
                    {{ anrede }}
                </h2>

                <div class="user-form flex-column">
                    <user-edit class="my-2" :user="user" @user-saved="handleUserSaved" />
                </div>

                <div class="user-rollen flex-column mt-4">
                    <h3 class="">Rollen</h3>
                    <user-rollen :user-id="userId" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import UserRollen from '@/js/components/Benutzer/UserRollen.vue'
    import UserEdit from '@/js/components/Benutzer/UserEdit.vue'
    import { useUserStore } from '@/js/stores/user'
    import { computed, onMounted } from 'vue'

    const props = defineProps({
        userId: {
            type: String,
            required: true
        }
    })

    const userStore = useUserStore()

    onMounted(async () => {
        await userStore.fetchUsers()
    })

    const isLoading = computed(() => userStore.isLoading)
    const user = computed(() => userStore.getUserById(props.userId))

    const anrede = computed(() => {
        if (!user.value) {
            return ''
        }
        return `${user?.value.titel} ${user?.value.vorname} ${user?.value.nachname}`
    })

    const handleUserSaved = async (userData) => {
        await userStore.saveUser(props.userId, { ...userData.value })
    }
</script>

<script></script>

<style lang="scss">
    .user-form {
        flex-grow: 1;
        width: 75%;
    }

    .user-rollen {
        flex-grow: 1;
        width: 75%;
    }
</style>
